"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentTime = exports.stringToTime = exports.getTimeString = exports.getOptions = exports.toString = void 0;
var TimePicker_1 = require("./TimePicker");
var toString = function (value) { return ("" + value).padStart(2, '0'); };
exports.toString = toString;
var getOptions = function (range) {
    return Array.from({ length: range }, function (_, index) { return exports.toString(index); });
};
exports.getOptions = getOptions;
var getTimeString = function (_a, hour12) {
    var hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds, amPm = _a.amPm;
    if (hour12 === void 0) { hour12 = false; }
    
    var h = parseInt(hours, 10);
    var m = parseInt(minutes, 10);
    var s = parseInt(seconds, 10);

    if (amPm) {
        var amPmLower = amPm.toLowerCase();
        if (amPmLower === 'pm' && h < 12) {
            h += 12;
        } else if (amPmLower === 'am' && h === 12) {
            h = 0;
        }
    }
    
    var dateString = "2000-01-01 " + String(h).padStart(2, '0') + ":" + String(m).padStart(2, '0') + ":" + String(s).padStart(2, '0');
    var date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return '';
    }
    var out = date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: hour12,
    });
    if (out.startsWith('24')) {
        return out.replace('24', '00');
    }
    return out;
};
exports.getTimeString = getTimeString;
var stringToTime = function (timeString, hour12) {
    if (timeString === void 0) { timeString = ''; }
    if (hour12 === void 0) { hour12 = false; }
    if (!timeString) {
        return undefined;
    }
    var date = new Date("0000 " + timeString);
    var _a = date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: hour12,
    }).replace(' ', ':').split(':').map(exports.toString), hours = _a[0], minutes = _a[1], seconds = _a[2], amPm = _a[3];
    return {
        hours: hours.replace('24', '00'),
        minutes: minutes,
        seconds: seconds,
        amPm: amPm,
    };
};
exports.stringToTime = stringToTime;
var getParsedTime = function (date) {
    if (date instanceof Date && isNaN(date.valueOf())) {
        return TimePicker_1.DEFAULT_TIME;
    }
    var _a = date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false,
    }).split(/[\s:]+/), hh = _a[0], mm = _a[1], ss = _a[2];
    var time = { hours: exports.toString(hh), minutes: exports.toString(mm), seconds: exports.toString(ss) };
    return time;
};
var getCurrentTime = function () { return getParsedTime(new Date()); };
exports.getCurrentTime = getCurrentTime;
